import _ from "lodash";

export class VehiculeFlotte {
    id?: number;
    numero: string = "";
    immatriculation: string = "";
    marque: string = "";
    modele: string = "";
    chauffeur_id?: number = null;
    chauffeur_nom: string = "";
    actif: boolean = true;

    constructor(data?: any) {
        if (data) {
            _.assign(this, data);
        }
    }

    serialize(): any {
        return {
            id: this.id,
            numero: this.numero,
            immatriculation: this.immatriculation,
            marque: this.marque || "",
            modele: this.modele || "",
            chauffeur_id: this.chauffeur_id || null,
            actif: this.actif,
        };
    }
}

export class DefautControle {
    id?: number;
    controle_vehicule_id?: number;
    section_code: string = "";
    point_code: string = "";
    valeur: string = "";
    note: string = "";
    statut: string = "";
    label?: string;
    recommendation?: string;
    priority: string = "normal";

    constructor(data?: any) {
        if (data) {
            _.assign(this, data);
        }
    }
}

export class EntretienVehicule {
    id?: number;
    vehicule_id?: number;
    type: string = "";
    label: string = "";
    date: ?string;
    kilometrage?: number;
    cout?: number;
    prestataire: string = "";
    notes: string = "";

    constructor(data?: any) {
        if (data) {
            _.assign(this, data);
        }
    }

    serialize(): any {
        return {
            id: this.id,
            vehicule_id: this.vehicule_id,
            type: this.type,
            label: this.label,
            date: this.date,
            kilometrage: this.kilometrage || null,
            cout: this.cout || null,
            prestataire: this.prestataire || "",
            notes: this.notes || "",
        };
    }
}

export class ControleVehicule {
    id?: number;
    vehicule_id?: number;
    chauffeur_id?: number = null;
    chauffeur_nom: string = "";
    reference: string = "";
    date_controle: ?string;
    kilometrage: number = 0;
    signature_controleur?: string;
    signature_chauffeur?: string;
    chauffeur_absent: boolean = false;
    vehicule?: VehiculeFlotte;
    defauts: Array<DefautControle> = [];

    constructor(data?: any) {
        if (data) {
            _.assign(this, _.omit(data, ["vehicule", "defauts"]));
            if (data.vehicule) {
                this.vehicule = new VehiculeFlotte(data.vehicule);
            }
            if (data.defauts) {
                this.defauts = _.map(
                    data.defauts,
                    (d) => new DefautControle(d)
                );
            }
        }
    }

    get nbDefauts(): number {
        return this.defauts ? this.defauts.length : 0;
    }
}
